module.exports = __webpack_public_path__ + "images/social-icons/f_logo_RGB-White_32-1a9a9c794a6c88bc63e13e9ad1fc83db.png";